import React from 'react';
import { WeatherData } from "../type/types";
import styled from "styled-components"

interface Props {
    weather: WeatherData | undefined;
    country: WeatherData | undefined;
    // temp: WeatherData;
}

const PrintWeather = ({ weather, country}: Props) => {
    // try {
    //     let countryCode = weather?.sys.country;
        let countryName = new Intl.DisplayNames(['en'], {type: 'region'});
        // console.log(countryName.of(`KR`));
        // console.log("print",weather, country);
        let countryFullName;
        // console.log(countryName.of(`${countryCode}`));

        // const getL = (c: string) => new Intl.DisplayNames(['en'], {type: 'region'}).of(c);

        function getCountryName(country : string) {
            try{
                // getL(`${country}`);
                // console.log(countryName.of(`${country}`));
                // countryFullName = countryName.of(`${country}`);
                return countryName.of(`${country}`);
                // console.log("country name", countryFullName)
            }catch(error){
                console.log("error",error);
            }
        };
        countryFullName = getCountryName(`${country}`);

        // let countryCode = weather?.sys.country;
        // console.log("weather", countryName.of(`${countryCode}`));
        // console.log(countryName.of(`{weather.sys.country}`));
        // console.log("country code",typeof(weather?.main.temp), countryCode);
        let temperature = weather?.main.temp;
        // let temperature = temp;
        // let temp2;

        function getTemp(temp : number){
            try{
                return Math.round(temp);
                console.log("temp", Math.round(temp))
            }catch(error){
                console.log(error);
            }
        }

        // let temp2 = getTemp(temp);
        console.log("temp", temperature, Math.round(Number(temperature)));
        let temp = Math.round(Number(temperature));
        // let tempC = getTemp(Number(temperature));
        // let tempF = (getTemp(Number(temperature))*1.8) + 32;
        return (
            <Container>
                <WeatherInfo>{weather?.name},
                    {/*{weather?.sys.country}*/}
                    {' '}
                    {countryFullName}

                </WeatherInfo>
                <WeatherInfo>{weather?.weather[0].description}</WeatherInfo>
                <WeatherInfo>{temp} °C
                    {' '}
                    ({Math.round(Number(temp*1.8 +32))}°F)
                </WeatherInfo>
            </Container>
        );
        // }
    // } catch (error) {
    //     console.log(error);
    // }
}

export default PrintWeather;

const Container = styled.div``;
const WeatherInfo = styled.h2`
    color: black;
    `;
